import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Article, ArticleHome } from '@models/article';
import { Author } from '@models/author';
import { FormComponent } from '@classes/form';
import { Magazine } from '@models/magazine';
import { Media } from '@models/media';
import { MediaSubject } from '@models/media-subject';
import { Short } from '@models/short';
import { Tag } from '@models/tag';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';
import { Carousel } from '@components/carousel/carousel';
import { SafeEmbedPipe } from '@pipes/safe-embed-pipe.pipe';
import { Content } from '@components/content/content';

export class HomeMedia {
  articles: ArticleHome[] = [];
  authors: Author[] = [];
  hindsight: Article[] = [];
  knowmore: Article[] = [];
  latest: Article[] = [];
  magazine: Magazine | null = null;
  marticles: Article[] = [];
  medias: Media[] = [];
  moreread: Article[] = [];
  presents: Article[] = [];
  shorts: Short[] = [];
  subjects: MediaSubject[] = [];
  tags: Tag[] = [];
  videos: Article[] = [];
}

@Component({
  selector: 'app-home',
  imports: [
    NgClass,
    RouterLink,
    AssetFormatterPipe,
    Carousel,
    SafeEmbedPipe,
    Content,
  ],
  templateUrl: './home.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.scss',
})
export class Home extends FormComponent {
  private readonly sanitizer = inject(DomSanitizer);

  override data = signal<HomeMedia>(new HomeMedia());

  protected embedUrl(youtubeId: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${youtubeId}`,
    );
  }

  ngOnInit(): void {
    this.loadEndpoint = 'api/home';

    this.load();
  }

  override onLoadSuccess(response: any): void {
    this.data.set(response.data);

    super.onLoadSuccess(response);
  }
}
